import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { FullLayoutComponent } from './components/full-layout/full-layout.component';
import { AuthGuard } from './auth.guard';
import { CommonService } from './services/common.service';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
// import { TaxonomyDashboardComponent } from './pages/taxonomy-dashboard/taxonomy-dashboard.component';
import { CreateDashboardComponent } from './pages/user-dashboard/create-dashboard/create-dashboard.component';
import { ReportComponent } from './components/report/report.component';
import { TaxonomyDashboardV2Component } from './pages/taxonomy-dashboard-v2/taxonomy-dashboard-v2.component';
import { TaxonomyPageComponent } from './pages/taxonomy-dashboard-v2/taxonomy-page/taxonomy-page.component';
import { TaxonomySettingsComponent } from './pages/taxonomy-dashboard-v2/taxonomy-settings/taxonomy-settings.component';

export const routes: Routes = [
  {
    path: '',
    component: FullLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', loadChildren: () => [{ path: '', component: DashboardComponent }] },
      { path: 'conversation-insights', loadChildren: () => [{ path: '', component: DashboardComponent }] },
      {
        path: 'taxonomy-dashboard',
        loadChildren: () => [{ path: '', component: TaxonomyDashboardV2Component }],
      },
      {
        path: 'taxonomy-dashboard/:id',
        loadChildren: () => [{ path: '', component: TaxonomyPageComponent }],
      },
      // {
      //   path: 'user-dashboard',
      //   loadChildren: () => [{ path: '', component: UserDashboardComponent }],
      // },
      {
        path: 'create-dashboard',
        loadChildren: () => [{ path: '', component: CreateDashboardComponent }],
      },
      {
        path: 'report',
        loadChildren: () => [{ path: '', component: ReportComponent }],
      },
      {
        path: 'settings',
        loadChildren: () => [{ path: '', component: TaxonomySettingsComponent }],
      },
    ],
  },
  { path: 'login', component: LoginComponent },
  { path: '**', component: LoginComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [CommonService],
  exports: [RouterModule],
})
export class AppRoutingModule {}
